module.exports = __webpack_public_path__ + "images/agents-forge-section-left.68691bd423b284ac5cc0486a27e0b150.png";